import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function CTASection() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-br from-zinc-950 via-background to-zinc-950 border-y border-zinc-800">
      <div className="max-w-4xl mx-auto px-6 text-center reveal">
        <div className="flex items-center justify-center gap-4 mb-6 animate-fade-in">
          <div className="w-[2px] h-4 bg-amber-500" />
          <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
            Ready to Get Started?
          </span>
        </div>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-8 text-white animate-slide-up">
          Ready to Elevate<br />Your Brand?
        </h2>
        <p className="text-lg md:text-xl text-zinc-400 mb-12 max-w-2xl mx-auto animate-fade-in-delay">
          Let's discuss how we can transform your digital presence and drive real results for your business.
        </p>

        {/* CTA Images */}
        <div className="grid grid-cols-3 gap-4 mb-12 max-w-2xl mx-auto reveal">
          {[
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc7985e0-1767793703963.png", alt: 'Creative design process and brand development work' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_17141f68f-1768208600512.png", alt: 'Social media marketing content creation and strategy planning' },
          { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1e5b08612-1766558211927.png", alt: 'Digital marketing workspace with creative tools and devices' }]?.
          map((img, idx) =>
          <div
            key={idx}
            className="relative aspect-square rounded-xl overflow-hidden group hover-lift"
            style={{ animationDelay: `${idx * 100}ms` }}>
            
              <AppImage
              src={img?.src}
              alt={img?.alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
            
              <div className="absolute inset-0 bg-gradient-to-t from-amber-500/30 to-transparent opacity-0 group-hover:opacity-100 transition-all" />
            </div>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <Link
            href="/contact"
            className="group px-8 py-4 bg-amber-500 text-white rounded-xl hover:bg-amber-600 transition-all shadow-lg hover:shadow-amber-500/50 flex items-center justify-center gap-2 font-semibold">
            
            Get Started Today
            <Icon
              name="ArrowRightIcon"
              size={20}
              className="group-hover:translate-x-1 transition-transform" />
            
          </Link>
          <Link
            href="/services"
            className="px-8 py-4 border border-zinc-700 text-white rounded-xl hover:bg-zinc-800 transition-all flex items-center justify-center gap-2 font-semibold">
            
            View All Services
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-left">
          {[
          {
            icon: 'PhoneIcon',
            title: 'Call Us',
            value: '9763150150',
            link: 'tel:9763150150'
          },
          {
            icon: 'EnvelopeIcon',
            title: 'Email Us',
            value: 'contact@classic24digital.com',
            link: 'mailto:contact@classic24digital.com'
          },
          {
            icon: 'MapPinIcon',
            title: 'Visit Us',
            value: 'View Location',
            link: 'https://www.google.com/maps/place/Classic24+Digital+Solutions/@19.2212296,73.162009,17z'
          }].
          map((contact) =>
          <a
            key={contact.title}
            href={contact.link}
            target={contact.icon === 'MapPinIcon' ? '_blank' : undefined}
            rel={contact.icon === 'MapPinIcon' ? 'noopener noreferrer' : undefined}
            className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 hover:border-amber-500/30 transition-all glow-hover group">
            
              <Icon
              name={contact.icon as any}
              size={24}
              className="text-amber-500 mb-3" />
            
              <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">
                {contact.title}
              </div>
              <div className="text-sm font-semibold text-white group-hover:text-amber-500 transition-colors">
                {contact.value}
              </div>
            </a>
          )}
        </div>
      </div>
    </section>);

}